"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _index = require("@/api/education/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称/编码"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "名称",
        prop: "name",
        isShow: true,
        width: "150"
      }, {
        name: "编码",
        prop: "uniqueCode",
        isShow: true,
        width: "150"
      }, {
        name: "创建日期",
        prop: "createTime",
        isShow: true,
        width: "100"
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      name: "",
      funBtns: [
      // {
      //   size: "small",
      //   click: "deleteById",
      //   icon: "el-icon-delete",
      //   name: "批量删除",
      //   type: "danger"
      // },
      {
        size: "small",
        click: "add",
        icon: "el-icon-circle-plus-outline",
        name: "新增",
        type: "primary"
      }],
      options: [{
        name: "编辑",
        class: "edit",
        option: "editBureau",
        span: 3
      }, {
        name: "查看管理员",
        class: "editor",
        option: "viewAdmin",
        span: 3
      }
      // {
      //   name: "删除",
      //   class: "delet",
      //   option: "deleteById",
      //   span: 3
      // }
      ],
      checkBoxs: []
    };
  },
  methods: {
    // 查看管理员
    viewAdmin: function viewAdmin(e) {
      this.$router.push({
        path: "/schoolTest/educationAdminList",
        query: {
          id: e.id,
          title: e.name
        }
      });
    },
    // 搜索框
    search: function search(v) {
      this.name = v.queryValue;
      this.getEducationList();
    },
    // 编辑按钮操作
    editBureau: function editBureau(row) {
      this.$router.push({
        path: "/schoolTest/educationList-edit",
        query: {
          id: row.id
        }
      });
    },
    // 新增按钮操作
    add: function add() {
      this.$router.push("/schoolTest/educationList-add");
    },
    // 删除按钮
    deleteById: function deleteById(row) {
      var _this = this;
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _index.educationDel)({
          idList: id
        }).then(function () {
          _this.getEducationList();
          _this.$message.success("操作成功。");
        });
      }).catch(function () {
        _this.$message.info("取消删除。");
      });
    },
    // 设置管理员
    setSys: function setSys() {
      // this.$router.push("/province/provinceList-setSys");
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var _this2 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this2.checkBoxs.push(item.id);
      });
    },
    distribution: function distribution() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getEducationList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getEducationList();
    },
    // 获取教育局列表
    getEducationList: function getEducationList() {
      var _this3 = this;
      (0, _index.educationList)({
        name: this.name,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize,
        cityId: ""
      }).then(function (res) {
        var data = res.data;
        _this3.totalData = data.total;
        _this3.listData = data.list;
      }).catch(function (e) {
        return e;
      });
    }
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  },
  created: function created() {
    this.getEducationList();
  }
};